import { Stack } from '@mui/material';
import React from 'react';
import SideBar from '../SideBar';

interface Props {
  children: React.ReactNode;
}
const WidthSideBar = ({ children }: Props) => {
  return (
    <Stack direction="row">
      <SideBar />
      <Stack flex={1}>{children}</Stack>
    </Stack>
  );
};

export default WidthSideBar;
